<div class="container">
	<div id="headerRegion" class="row"></div>
	<div id="actionsRegion" class="row"></div>
	<div id="alertsRegion" class="row"></div>
</div>
